// ROLES DISPONIBLES EN LA APP

//   interfaz Rol
export interface IRol {
    valor: string;
    texto: string;
    clase: string;
}

// Array de roles disponibles
export const ROLES: IRol[] = [
    { valor: 'sa', texto: 'Super Admin', clase: 'bg-info text-white' },
    { valor: 'admin', texto: 'Admin', clase: 'bg-warning text-white' },
    { valor: 'admin_02', texto: 'Admin Consultas', clase: 'bg-warning text-yellow' },
    { valor: 'usuario', texto: '▶︎ Usuario Pda', clase: 'bg-dark text-white' },
    { valor: 'cliente', texto: 'Cliente', clase: 'bg-success text-white' },
    { valor: 'rotobox', texto: '⚙︎ RotoBox', clase: 'bg-secondary text-white' },
];
